import { ValueBridge } from './ValueBridge';
export class UsbHostBridge extends ValueBridge {
    constructor(name, state, control, usbHosts, controlInfo, powerState, transport, valueCallback, log) {
        super(name, state, control, controlInfo, powerState, transport, valueCallback, log);
        this.usbHosts = usbHosts;
    }
    convertFromParam(hostId) {
        if (hostId === null) {
            this.log.error(`${this.name}: hostId is null`);
            return this.state.value;
        }
        const usbInput = this.usbHosts[hostId];
        if (!usbInput) {
            this.log.error(`${this.name}: no usb host config for hostId: ${hostId}`);
            return this.state.value;
        }
        return usbInput.code;
    }
    convertToParam(code) {
        const usbInputs = this.usbHosts;
        for (const [hostId, usbInput] of Object.entries(usbInputs)) {
            if (usbInput.code === code) {
                return hostId;
            }
        }
        this.log.info(`${this.name}: no usb host configured for code: ${code}`);
        return null;
    }
}
